import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { LoadDismissablePromptsAction } from '../../domains/dismissablePrompts/actions.types';
import type { DismissPromptByTypeAction } from '../../domains/dismissablePromptsByType/actions.types';

import type { DismissablePromptsByType } from './types';

export type DismissablePromptsAction = DismissPromptByTypeAction | LoadDismissablePromptsAction;

const initialState: DismissablePromptsByType = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<DismissablePromptsByType, DismissablePromptsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'DISMISSABLE_PROMPTS_BY_TYPE.DISMISS_PROMPT_FULFILLED':
      return update(state, action.payload.promptType, { isDismissed: true });
    case 'DISMISSABLE_PROMPTS.LOAD_PENDING':
      return moveToPending(state, action.payload.promptTypes);
    case 'DISMISSABLE_PROMPTS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.dismissablePromptsByType);
    case 'DISMISSABLE_PROMPTS.LOAD_REJECTED':
      return moveToRejected(state, action.payload.promptTypes, action.payload.error);
    default:
      return state;
  }
};

export default reducer;
